// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  DataLayerPageAction,
  DataLayerPageLoad,
  DataLayerError,
} from '@cigna/shared/angular/analytics-data-access';
import { ServiceError } from '@cigna/cigna-for-brokers/shared/util';
import { createAction, props } from '@ngrx/store';
import {
  GetWelcomeTileResponse,
  InstantALertData,
  SearchClientResponse,
  SearchClientRequest,
  AlertResponse,
  AlertDismissRequest,
  CheckIpValidRequest,
  CheckIpValidResponse,
  UserAgreeAcceptParam,
  UserAgreementResponse,
  UserAgreeAcceptResponse,
  GetBrNavigationsResponse,
  ToolsResponse,
  OnboardingBasicInfo,
  OnboardingAddressInfo,
  OnBoardingCommercial,
  OnBoardingIfp,
  OnBoardingMa,
} from './appstate.models';

export const getAlerts = createAction('[API] Get Alerts');

export const getAlertsSuccess = createAction(
  '[API] Get Alerts Success',
  props<{ payload: AlertResponse }>(),
);

export const updateUserType = createAction(
  '[API] Update User Type',
  props<{ flag: boolean }>(),
);
export const getAlertsFailure = createAction(
  '[API] Get Alerts Failure',
  props<{ error: ServiceError }>(),
);
export const getUserAgreement = createAction('[API] Get UserAgreement');

export const getUserAgreementSuccess = createAction(
  '[API] Get UserAgreement Success',
  props<{ payload: UserAgreementResponse }>(),
);

export const getUserAgreementFailure = createAction(
  '[API] Get UserAgreement Failure',
  props<{ error: ServiceError }>(),
);
export const dismissAlert = createAction(
  '[API] Dismiss Alert',
  props<{ dismissAlertRequest: AlertDismissRequest }>(),
);
export const dismissAlertSuccess = createAction(
  '[API] Dismiss Alert Success',
  props<{ payload: AlertResponse; alertMsgId: string[] }>(),
);

export const dismissAlertFailure = createAction(
  '[API] Dismiss Alert Failure',
  props<{ error: ServiceError }>(),
);

export const getBrokerNavigations = createAction(
  '[API] Get Broker Navigations',
);

export const getBrokerNavigationsSuccess = createAction(
  '[API] Get Broker Navigations Success',
  props<{ payload: GetBrNavigationsResponse }>(),
);

export const getBrokerNavigationsFailure = createAction(
  '[API] Get Broker Navigations Failure',
  props<{ error: ServiceError }>(),
);

export const getWelcomeTileSuccess = createAction(
  '[API] Get Welcome Tile Success',
  props<{ payload: GetWelcomeTileResponse }>(),
);

export const getWelcomeTileFailure = createAction(
  '[API] Get Welcome Tile Failure',
  props<{ error: ServiceError }>(),
);
export const getBusinessAlerts = createAction('[API] Get Business Alerts');
export const getBusinessAlertsSuccess = createAction(
  '[API] Get Business Alerts Success',
  props<{ payload: InstantALertData }>(),
);
export const getBusinessAlertFailure = createAction(
  '[API] Get Business Alerts Failure',
  props<{ error: ServiceError }>(),
);
export const searchClient = createAction(
  '[API] Search Client',
  props<{ searchClientRequest: SearchClientRequest }>(),
);
export const searchClientSuccess = createAction(
  '[API] Get Search Client Success',
  props<{ payload: SearchClientResponse }>(),
);

export const searchClientFailure = createAction(
  '[API] Get Search Client Failure',
  props<{ error: ServiceError }>(),
);

export const checkIpValid = createAction(
  '[API] checkIpValid',
  props<{ checkIpValidRequest: CheckIpValidRequest }>(),
);
export const checkIpValidSuccess = createAction(
  '[API] checkIpValid Success',
  props<{ payload: CheckIpValidResponse }>(),
);

export const checkIpValidFailure = createAction(
  '[API] checkIpValid Failure',
  props<{ error: ServiceError }>(),
);

export const logout = createAction(
  '[Page] LogOut',
  props<{ variation: string; linkName: string }>(),
);

export const impersonatorLogoutPost = createAction(
  '[Page] LogOut POST',
  props<{ isSignin: boolean }>(),
);

export const impersonatorLogoutGet = createAction(
  '[Page] LogOut GET',
  props<{ isSignin: boolean }>(),
);

export const impersonatorLogoutSuccess = createAction(
  '[Page] LogOut Success',
  props<{ isSignin: boolean }>(),
);

export const staySignIn = createAction('[Page] StaySignIn');

export const resizeSideNavToggle = createAction(
  '[Page] resizeSideNavToggle',
  props<{ open: boolean }>(),
);

export const windowOpen = createAction(
  '[Page] windowOpen',
  props<{ url: string; target: string }>(),
);

export const appRedirect = createAction(
  '[Page] appRedirect',
  props<{ redirect: string }>(),
);
export const updateTermsAgreementStatus = createAction(
  '[API] Post Update TermsAgreementStatus',
  props<{ acceptReqest: UserAgreeAcceptParam }>(),
);
export const updateTermsAgreementStatusSuccess = createAction(
  '[API] Post Update TermsAgreementStatus Success',
  props<{ payload: UserAgreeAcceptResponse }>(),
);

export const updateTermsAgreementStatusFailure = createAction(
  '[API] Post Update TermsAgreementStatus Failure',
  props<{ error: ServiceError }>(),
);

export const legalAffirmStatus = createAction(
  '[API] Should Legal-Affirmation Open',
  props<{ open: boolean }>(),
);

export const getTools = createAction('[API] Get Tools');
export const getToolsSuccess = createAction(
  '[API] Get Tools Success',
  props<{ payload: ToolsResponse }>(),
);
export const getToolsFailure = createAction(
  '[API] Get Tools Failure',
  props<{ error: ServiceError }>(),
);

export const statementAccessRequest = createAction(
  'Enable Statement Access request pop up',
  props<{ isEnabled: boolean }>(),
);
export const sendAnalytics = createAction(
  '[Analytics] send analytics',
  props<{ data: DataLayerPageAction | DataLayerPageLoad | DataLayerError }>(),
);
export const setLob = createAction(
  '[Analytics] set lob before login',
  props<{ lob: string | undefined }>(),
);

export const setLastVisitedUser = createAction(
  '[Analytics] set last Visited User',
  props<{ lastVisitedUser: string | undefined }>(),
);

export const addBasicInfo = createAction(
  '[SAVE-BASIC-INFO] save onboarding basic info',
  props<OnboardingBasicInfo>(),
);

export const addAddress = createAction(
  '[SAVE-ADDRESS-INFO] save onboarding address info',
  props<OnboardingAddressInfo>(),
);

export const addCommercialFlag = createAction(
  '[SAVE-COMMERCIAL-FLAG] save onboarding commercial flag',
  props<{ isCommercialOpted: boolean }>(),
);

export const addIfpFlag = createAction(
  '[SAVE-IFP-FLAG] save onboarding ifp flag',
  props<{ isIfpOpted: boolean }>(),
);

export const addMaFlag = createAction(
  '[SAVE-MA-FLAG] save onboarding ma flag',
  props<{ isMaOpted: boolean }>(),
);

export const addContinueCommercial = createAction(
  '[SAVE-COMMERCIAL-CONTINUE-FLAG] save onboarding commercial continue flag',
  props<{ isContinueCommercial: boolean }>(),
);

export const addContinueIfp = createAction(
  '[SAVE-IFP-CONTINUE-FLAG] save onboarding ifp continue flag',
  props<{ isContinueIfp: boolean }>(),
);

export const addContinueMa = createAction(
  '[SAVE-MA-CONTINUE-FLAG] save onboarding ma continue flag',
  props<{ isContinueMa: boolean }>(),
);

export const addCommercialInfo = createAction(
  '[SAVE-COMMERCIAL-INFO] save onboarding commercial info',
  props<OnBoardingCommercial>(),
);

export const addIfpInfo = createAction(
  '[SAVE-IFP-INFO] save onboarding ifp info',
  props<OnBoardingIfp>(),
);

export const addMaInfo = createAction(
  '[SAVE-MA-INFO] save onboarding ma info',
  props<OnBoardingMa>(),
);

export const deleteOnboardingInfo = createAction(
  '[DELETE-ONBOARDING-INFO] delete onboarding ma info',
  props<{ isStash: boolean }>(),
);
